const searchBtnToggle = document.querySelector('.search');
const searchBtn = document.querySelector('.search-btn');
const searchBox = document.querySelector('.search-box');
const searchInput = document.querySelector('.search-box input');

searchBtnToggle.addEventListener('click', function() {
  if (searchBox.clientWidth === 0) {
    searchBox.style.width = '200px';
    searchInput.focus();
  } else {
    searchBox.style.width = '0';
  }
});

searchBtn.addEventListener('click', function() {
  // Perform search
  search();
});

searchInput.addEventListener('keydown', function(event) {
  if (event.key === 'Enter') {
    // Prevent form submission
    event.preventDefault();
    // Perform search
    search();
  }
});

document.addEventListener('click', function(e) {
  if (!searchBox.contains(e.target) && searchBox.clientWidth > 0) {
    searchBox.style.width = '0';
  }
});

window.addEventListener('resize', function() {
  if (window.innerWidth <= 992) {
    searchBox.style.width = '100%';
  } else {
    searchBox.style.width = '';
  }
});

function search() {
  // Code to perform search
}





const aboutBgTitle = document.querySelector('.about__bg-title');
if (aboutBgTitle !== null) {
  const text = aboutBgTitle.textContent;
  aboutBgTitle.textContent = "";

  let i = 0;

  function type() {
    if (isElementInViewport(aboutBgTitle) && i < text.length) {
      aboutBgTitle.textContent += text.charAt(i);
      i++;
      setTimeout(type, 1000);
    } else if (i >= text.length) {
      aboutBgTitle.classList.add("typed");
    } else {
      setTimeout(type, 1000);
    }
  }

  function isElementInViewport(el) {
    const rect = el.getBoundingClientRect();
    return (
      rect.top >= 0 &&
      rect.left >= 0 &&
      rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
      rect.right <= (window.innerWidth || document.documentElement.clientWidth)
    );
  }

  window.addEventListener('scroll', () => {
    type();
  });
}




